import React, { useEffect, useState } from 'react';
import CountdownGauge  from "./CountdownGauge";

const CountdownTimer = ({ duration, threshold }) => {
    const [timeLeft, setTimeLeft] = useState(duration);

    // Format seconds into MM:SS
    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    };

    useEffect(() => {
        // Stop the timer if timeLeft reaches zero
        if (timeLeft <= 0) return;

        const timerId = setInterval(() => {
            setTimeLeft(prevTime => {
                // Stop the interval when the timer is about to hit 0
                if (prevTime <= 1) {
                    clearInterval(timerId);
                    return 0;
                }
                return prevTime - 1;
            });
        }, 1000);

        // Cleanup the interval on unmount or when timeLeft changes
        return () => clearInterval(timerId);
    }, [timeLeft]);

    return (
        <>
            <CountdownGauge duration={duration}
                            timeLeft={timeLeft}
                            threshold={threshold}
                            radius={100}
                            stroke={50}
            />
            <div style={{ fontSize: '5rem', 'font-weight': 'bold', color: timeLeft <= threshold ? 'red' : 'black', 'margin-top':'1rem' }}>
                {formatTime(timeLeft)}
            </div>
        </>
    );
};

export default CountdownTimer;
